import { render, staticRenderFns } from "./PermissionInfo.vue?vue&type=template&id=5879b612&scoped=true"
import script from "./PermissionInfo.vue?vue&type=script&lang=js"
export * from "./PermissionInfo.vue?vue&type=script&lang=js"
import style0 from "./PermissionInfo.vue?vue&type=style&index=0&id=5879b612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879b612",
  null
  
)

export default component.exports